import {Component, OnChanges, Input} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {Router} from '@angular/router';
/**
 * Acá importamos el JSON con los mensajes de respuesta para todo el proyecto.
 */
import Messages from './mensajes.json';
import Swal from 'sweetalert2';
import {environment} from '../../../environments/environment';


@Component({
  selector: 'app-mensajes',
  templateUrl: './mensajes.component.html',
  styleUrls: ['./mensajes.component.css']
})
export class MensajesComponent implements OnChanges {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código de mensaje enviado en los otros componentes.
   * titulo: Título de mensaje enviado en los otros componentes.
   * detalle: Detalle de mensaje enviado en los otros componentes.
   */
  @Input() code: any;
  @Input() titulo: any;
  @Input() detalle: any;
  showMsg = false;
  tipoMsg = '';
  tituloMsg = '';
  detalleMsg = '';

  // Variables para SweetAlert
  @Input() sw: any;
  minutosAntesRefreshToken = environment.minutosAntesRefreshToken;
  segundosModalRefreshToken = environment.segundosModalRefreshToken;
  refreshTokenTimeout;

  constructor(private authService: AuthService,
              private router: Router) {
  }

  ngOnChanges(): void {
    if (this.code) {
      this.mensajes(this.code, this.titulo, this.detalle);
    } else if (this.sw) {
      this.startRefreshTokenTimer();
    }
  }

  mensajes(Co, Ti, Me): void {
    this.mostrarMensaje(Co, Ti, Me);
  }

  mostrarMensaje(codigo: string, titulo: string, detalle: string): void {
    this.tipoMsg = Messages[codigo].tipo;
    this.tituloMsg = titulo == null ? Messages[codigo].titulo : titulo;
    this.detalleMsg = detalle == null ? Messages[codigo].detalle : detalle;
    this.showMsg = true;

    setTimeout(() => {
      this.code = '';
      this.tipoMsg = '';
      this.tituloMsg = '';
      this.detalleMsg = '';
      this.showMsg = false;
    }, 500);
  }

  startRefreshTokenTimer(): void {
    this.stopRefreshTokenTimer();
    const token = localStorage.getItem('at');
    const jwtToken = JSON.parse(atob(token.split('.')[1]));
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (Number(this.minutosAntesRefreshToken) * 60 * 1000);
    this.refreshTokenTimeout = setTimeout(() => {
      const porExpirar = Number(this.authService.verificarVencimientoToken());
      if (porExpirar === 2) {
        this.showSwal();
      } else if (porExpirar === 1 || porExpirar === 3) {
        this.startRefreshTokenTimer();
      } else if (porExpirar === 4) {
        this.cerrarSesion();
      }
    }, timeout);
  }

  showSwal(): void {
    Swal.fire({
      title: 'Sesión por expirar',
      text: 'La sesión está a punto de expirar, ¿necesitas más tiempo?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      focusConfirm: true,
      timer: this.segundosModalRefreshToken * 1000
    }).then((result) => {
      if (result.value) {
        this.siDialog();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.noDialog();
      } else {
        this.noDialog();
      }
    });
  }

  siDialog(): void {
    this.authService.refreshToken()
      .subscribe((resToken: any) => {
        if (resToken.success && resToken.status_code === 200) {
          this.authService.setToken(resToken.data.access_token);
          this.authService.setLoggedIn(true);
          this.startRefreshTokenTimer();
        }
      });
  }

  noDialog(): void {
    this.cerrarSesion();
  }

  stopRefreshTokenTimer(): void {
    clearTimeout(this.refreshTokenTimeout);
  }

  cerrarSesion(): void {
    this.router.navigate(['/auth/logout'], {queryParams: {skipUnsavedChangesGuard: true}});
  }

}
